module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "index"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMap),
      expression: "isShowMap"
    }],
    staticClass: "mydialog",
    attrs: {
      "id": "geolocation_mask"
    },
    on: {
      "click": _vm.hideMapDialog
    }
  }), _vm._v(" "), (_vm.isShowMap) ? _c('iframe', {
    attrs: {
      "sandbox": "allow-scripts allow-same-origin",
      "id": "miframe",
      "src": _vm.mapComponentURL,
      "frameborder": "0",
      "scrolling": "no",
      "width": "100%",
      "height": "100%"
    },
    on: {
      "mouseleave": function($event) {
        _vm.isShowMapBtn = true
      },
      "mouseenter": function($event) {
        _vm.isShowMapBtn = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    staticClass: "first",
    attrs: {
      "to": {
        path: '/main/chainmanage'
      },
      "replace": ""
    }
  }, [_vm._v("门店管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("创建分店")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoPage),
      expression: "infoPage"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "banner-btn",
    staticStyle: {
      "width": "190px"
    },
    on: {
      "click": _vm.fastEntry
    }
  }, [_vm._v("一键录入基础信息")])])]), _vm._v(" "), _c('div', {
    staticClass: "csup-panel-body"
  }, [_c('div', {
    staticClass: "sub_info_wrapper"
  }, [_c('el-form', {
    ref: "shop_info",
    attrs: {
      "model": _vm.shopInfo,
      "label-width": "96px",
      "label-position": "left",
      "rules": _vm.page1_rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分店登录密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "请输入新密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.password),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入账类型",
      "prop": "banktype"
    }
  }, [_c('el-select', {
    staticClass: "sub-account-item-info",
    attrs: {
      "placeholder": "请选择",
      "icon": "caret-bottom"
    },
    model: {
      value: (_vm.shopInfo.banktype),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "banktype", $$v)
      },
      expression: "shopInfo.banktype"
    }
  }, [_c('el-option', {
    key: 1,
    attrs: {
      "label": "对私",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "对公",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照类型",
      "prop": "licensetype"
    }
  }, [_c('el-select', {
    staticClass: "sub-account-item-info",
    attrs: {
      "placeholder": "请选择",
      "icon": "caret-bottom"
    },
    model: {
      value: (_vm.shopInfo.licensetype),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "licensetype", $$v)
      },
      expression: "shopInfo.licensetype"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": "无",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    key: 1,
    attrs: {
      "label": "个体工商户",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "企业",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group fix-unique"
  }, [_c('i', {
    staticClass: "divider-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("店铺基本信息")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人代表名称",
      "prop": "legalperson"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "如果没有法人，请填'无'",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.legalperson),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "legalperson", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.legalperson"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分店名称",
      "prop": "shopname"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.shopname),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "shopname", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.shopname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营类型",
      "prop": "shoptype_name"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "id": "op_type",
      "icon": "caret-bottom",
      "size": "small",
      "type": "select",
      "placeholder": "请选择经营类型",
      "readonly": ""
    },
    on: {
      "click": _vm.showTreeComponent
    },
    model: {
      value: (_vm.shopInfo.shoptype_name),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "shoptype_name", $$v)
      },
      expression: "shopInfo.shoptype_name"
    }
  }), _vm._v(" "), _c('el-tree', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopInfo.isShowTree),
      expression: "shopInfo.isShowTree"
    }],
    staticStyle: {
      "position": "absolute",
      "top": "32px",
      "z-index": "9",
      "width": "238px",
      "overflow-y": "auto",
      "height": "320px"
    },
    attrs: {
      "id": "op-type-tree",
      "data": _vm.shopInfo.shop_types,
      "props": _vm.defaultProps
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1), _vm._v(" "), _c('el-input', {
    ref: "longitude",
    staticClass: "hidden",
    attrs: {
      "type": "hidden",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.longitude),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "longitude", $$v)
      },
      expression: "shopInfo.longitude"
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "latitude",
    staticClass: "hidden",
    attrs: {
      "type": "hidden",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.latitude),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "latitude", $$v)
      },
      expression: "shopInfo.latitude"
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "provinceid",
    staticClass: "hidden",
    attrs: {
      "type": "hidden",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.provinceid),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "provinceid", $$v)
      },
      expression: "shopInfo.provinceid"
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "province",
    staticClass: "hidden",
    attrs: {
      "type": "hidden",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.province),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "province", $$v)
      },
      expression: "shopInfo.province"
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "city",
    staticClass: "hidden",
    attrs: {
      "type": "hidden",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.city),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "city", $$v)
      },
      expression: "shopInfo.city"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省份城市",
      "prop": "area_arr"
    }
  }, [_c('el-cascader', {
    staticClass: "sub-account-item-info",
    attrs: {
      "options": _vm.shopInfo.areaList
    },
    on: {
      "change": _vm.clickArea
    },
    model: {
      value: (_vm.shopInfo.area_arr),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "area_arr", $$v)
      },
      expression: "shopInfo.area_arr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺地址",
      "prop": "location"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "textarea",
      "rows": 2,
      "resize": "none",
      "placeholder": "点击右侧按钮打开地图",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.location),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "location", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.location"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-map",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.showMap
    }
  }, [_vm._v("地图定位店铺地址")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "详细门牌号",
      "prop": "address"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info-long",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.address),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sub-item-tip",
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "sub-account-item-info-long",
    staticStyle: {
      "line-height": "16px",
      "padding-top": "15px"
    }
  }, [_vm._v("\n              * 例：A座 底商1002号（如定位地址不够精确，请将店铺的地址一 并填写在详细地址栏中）\n            ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店内联系电话"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入顾客可联系的电话",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.landline),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "landline", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.landline"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#8a8c92"
    }
  }, [_vm._v("（选填）")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自定义编号",
      "prop": "store_id"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入自定义编号",
      "auto-complete": "off",
      "maxlength": _vm.storeidml
    },
    model: {
      value: (_vm.shopInfo.store_id),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "store_id", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.store_id"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#8a8c92"
    }
  }, [_vm._v("（选填）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group fix-unique"
  }, [_c('i', {
    staticClass: "divider-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("商户基础信息")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店主姓名",
      "prop": "ownerName"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请与收款卡号开户名一致",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.ownerName),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "ownerName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.ownerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "idnumber"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.idnumber),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "idnumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.idnumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px"
    },
    attrs: {
      "label": "证件有效期",
      "prop": "idstatdate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "clearable": false,
      "type": "date",
      "placeholder": "生效年月日",
      "align": "center",
      "popper-class": "adjustPoper"
    },
    model: {
      value: (_vm.shopInfo.idstatdate),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "idstatdate", $$v)
      },
      expression: "shopInfo.idstatdate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "20px",
      "display": "inline-block",
      "color": "#262424"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "inline-block",
      "width": "300px"
    },
    attrs: {
      "prop": "idenddate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "clearable": false,
      "type": "date",
      "placeholder": "失效年月日",
      "align": "center",
      "popper-class": "adjustPoper"
    },
    model: {
      value: (_vm.shopInfo.idenddate),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "idenddate", $$v)
      },
      expression: "shopInfo.idenddate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group fix-unique"
  }, [_c('i', {
    staticClass: "divider-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("绑定银行卡信息")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户名",
      "prop": "bankuser"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": (_vm.shopInfo.banktype === 2 && _vm.shopInfo.licensetype !== 0) ? '请与营业执照名称保持一致' : '请与店主姓名一致',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.bankuser),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "bankuser", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.bankuser"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行卡号",
      "prop": "bankaccount"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    on: {
      "blur": _vm.getCardsInfo
    },
    model: {
      value: (_vm.shopInfo.bankaccount),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "bankaccount", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.bankaccount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预留手机号",
      "prop": "bankmobile"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.bankmobile),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "bankmobile", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "shopInfo.bankmobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户地",
      "prop": "area_arr2"
    }
  }, [_c('el-cascader', {
    ref: "cascader",
    staticClass: "sub-account-item-info",
    attrs: {
      "options": _vm.shopInfo.areaList2
    },
    on: {
      "change": _vm.switchBankLocation
    },
    model: {
      value: (_vm.shopInfo.area_arr2),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "area_arr2", $$v)
      },
      expression: "shopInfo.area_arr2"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    ref: "adcode",
    staticClass: "hidden",
    attrs: {
      "type": "hidden",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.shopInfo.adcode),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "adcode", $$v)
      },
      expression: "shopInfo.adcode"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户总行",
      "prop": "headbankid"
    }
  }, [_c('el-select', {
    staticClass: "sub-account-item-info",
    attrs: {
      "placeholder": "请选择",
      "icon": "caret-bottom",
      "filterable": ""
    },
    on: {
      "change": _vm.switchHeadBank
    },
    model: {
      value: (_vm.shopInfo.headbankid),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "headbankid", $$v)
      },
      expression: "shopInfo.headbankid"
    }
  }, _vm._l((_vm.shopInfo.headbanks), function(hbank, index) {
    return _c('el-option', {
      key: hbank.headbankid + '@' + index,
      attrs: {
        "label": hbank.headbankname,
        "value": hbank.headbankid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "开户支行",
      "prop": "bankcode"
    }
  }, [_c('el-select', {
    ref: "branch_bank_select",
    staticClass: "sub-account-item-info",
    attrs: {
      "placeholder": "请选择",
      "icon": "caret-bottom",
      "filterable": ""
    },
    on: {
      "change": _vm.switchBranchBank
    },
    model: {
      value: (_vm.shopInfo.bankcode),
      callback: function($$v) {
        _vm.$set(_vm.shopInfo, "bankcode", $$v)
      },
      expression: "shopInfo.bankcode"
    }
  }, _vm._l((_vm.shopInfo.branchBanks), function(bbank) {
    return _c('el-option', {
      key: bbank.code,
      attrs: {
        "label": bbank.name,
        "value": bbank.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sub-item-tip",
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "sub-account-item-info-long"
  }, [(!!_vm.shopInfo.csphone) ? _c('span', [_vm._v("* 查询此银行卡的开户行请拨打：" + _vm._s(_vm.shopInfo.csphone))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-64px !important"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCreateSubShop('shop_info')
      }
    }
  }, [_vm._v("\n                放弃创建\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "155px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.btnLocked
    },
    on: {
      "click": _vm.preSignUp
    }
  }, [_vm._v("下一步")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding-bottom": "2px"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.infoPage),
      expression: "!infoPage"
    }],
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "csup-panel-body"
  }, [_c('div', {
    staticClass: "sub_info_wrapper"
  }, [_c('el-form', {
    ref: "license_info",
    attrs: {
      "model": _vm.license,
      "label-width": "96px",
      "label-position": "left",
      "rules": _vm.page1_rules
    }
  }, [(_vm.usertype !== 1) ? _c('el-form-item', {
    attrs: {
      "label": "营业执照名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.license.name),
      callback: function($$v) {
        _vm.$set(_vm.license, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "license.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.usertype !== 1) ? _c('el-form-item', {
    attrs: {
      "label": "营业执照编号",
      "prop": "licensenumber"
    }
  }, [_c('el-input', {
    staticClass: "sub-account-item-info",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.license.licensenumber),
      callback: function($$v) {
        _vm.$set(_vm.license, "licensenumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "license.licensenumber"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form', {
    ref: "upload_info",
    attrs: {
      "model": _vm.shopInfo,
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }), _vm._v(" "), (_vm.formList.includes('licensephoto')) ? _c('div', [_c('div', {
    staticClass: "panel-select-group fix-unique"
  }, [_c('i', {
    staticClass: "divider-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("营业执照图片")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.licensephotoloading),
      expression: "licensephotoloading"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterface,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'licensephoto',
        format: 'cors',
        userid: _vm.shopInfo.userid
      }
    }
  }, [(_vm.shopInfo.licensephoto_url) ? _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.shopInfo.licensephoto_url
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "img-tip"
  }, [_vm._v("重新上传")])]) : _c('div', {
    staticClass: "avatar-uploader-wrap"
  }, [_c('i', {
    staticClass: "avatar-uploader-icon el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-desc"
  }, [_vm._v("点击添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-tip"
  }, [_vm._v("支持jpg／png格式")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "example_img",
    attrs: {
      "src": require("./image/example6.jpg"),
      "width": "240",
      "height": "180",
      "class": "example_img"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "image_info"
  }, [_vm._v("* 必须使用有效期之内的营业执照，需要证件完整且文字清晰可见。")])], 1) : _vm._e(), _vm._v(" "), (_vm.formList.includes('authbankcardfront')) ? _c('div', [_c('div', {
    staticClass: "panel-select-group fix-unique"
  }, [_c('i', {
    staticClass: "divider-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("收款银行卡正面图片")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.authbankcardfrontloading),
      expression: "authbankcardfrontloading"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterface,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'authbankcardfront',
        format: 'cors',
        userid: _vm.shopInfo.userid
      }
    }
  }, [(_vm.shopInfo.authbankcardfront_url) ? _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.shopInfo.authbankcardfront_url
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "img-tip"
  }, [_vm._v("重新上传")])]) : _c('div', {
    staticClass: "avatar-uploader-wrap"
  }, [_c('i', {
    staticClass: "avatar-uploader-icon el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-desc"
  }, [_vm._v("点击添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-tip"
  }, [_vm._v("支持jpg／png格式")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "example_img",
    attrs: {
      "src": require("./image/example7.jpg"),
      "width": "240",
      "height": "180",
      "class": "example_img"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "image_info"
  }, [_vm._v("* 请上传有效的收款银行卡正面照片，保证画面清晰，内容完整。")])], 1) : _vm._e(), _vm._v(" "), (_vm.formList.includes('openlicense')) ? _c('div', [_c('div', {
    staticClass: "panel-select-group fix-unique"
  }, [_c('i', {
    staticClass: "divider-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("开户许可证图片")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.openlicenseloading),
      expression: "openlicenseloading"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterface,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'openlicense',
        format: 'cors',
        userid: _vm.shopInfo.userid
      }
    }
  }, [(_vm.shopInfo.openlicense_url) ? _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.shopInfo.openlicense_url
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "img-tip"
  }, [_vm._v("重新上传")])]) : _c('div', {
    staticClass: "avatar-uploader-wrap"
  }, [_c('i', {
    staticClass: "avatar-uploader-icon el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-desc"
  }, [_vm._v("点击添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-tip"
  }, [_vm._v("支持jpg／png格式")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "example_img",
    attrs: {
      "src": require("./image/example8.jpg"),
      "width": "240",
      "height": "180",
      "class": "example_img"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "image_info"
  }, [_vm._v("* 请上传有效的开户许可证照片，保证画面清晰，内容完整。")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group fix-unique"
  }, [_c('i', {
    staticClass: "divider-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("店铺门头图片")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.shopphotoloading),
      expression: "shopphotoloading"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterface,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'shopphoto',
        format: 'cors',
        userid: _vm.shopInfo.userid
      }
    }
  }, [(_vm.shopInfo.shopphoto_url) ? _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.shopInfo.shopphoto_url
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "img-tip"
  }, [_vm._v("重新上传")])]) : _c('div', {
    staticClass: "avatar-uploader-wrap"
  }, [_c('i', {
    staticClass: "avatar-uploader-icon el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-desc"
  }, [_vm._v("点击添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-tip"
  }, [_vm._v("支持jpg／png格式")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "example_img",
    attrs: {
      "src": require("./image/example1.jpg"),
      "width": "240",
      "height": "180",
      "class": "example_img"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "image_info"
  }, [_vm._v("* 请上传真实的店铺照片，请保证画面清晰，完整拍摄到店铺门头名称及店内陈设情况店铺门头图片。")]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group fix-unique"
  }, [_c('i', {
    staticClass: "divider-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("店内陈设图片")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.goodsphotoloading),
      expression: "goodsphotoloading"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterface,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'goodsphoto',
        format: 'cors',
        userid: _vm.shopInfo.userid
      }
    }
  }, [(_vm.shopInfo.goodsphoto_url) ? _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.shopInfo.goodsphoto_url
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "img-tip"
  }, [_vm._v("重新上传")])]) : _c('div', {
    staticClass: "avatar-uploader-wrap"
  }, [_c('i', {
    staticClass: "avatar-uploader-icon el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-desc"
  }, [_vm._v("点击添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-tip"
  }, [_vm._v("支持jpg／png格式")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "example_img",
    attrs: {
      "src": require("./image/example2.jpg"),
      "width": "240",
      "height": "180",
      "class": "example_img"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "image_info"
  }, [_vm._v("* 需露出门店环境的全景，如：服务时的场景、超市货架全景、餐厅全景等。")]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group fix-unique"
  }, [_c('i', {
    staticClass: "divider-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.usertype === 1 ? '收款人身份证图片' : '法人身份证图片'))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.idcardfrontloading),
      expression: "idcardfrontloading"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterface,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'idcardfront',
        userid: _vm.shopInfo.userid,
        format: 'cors'
      }
    }
  }, [(_vm.shopInfo.idcardfront_url) ? _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.shopInfo.idcardfront_url
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "img-tip"
  }, [_vm._v("重新上传>")])]) : _c('div', {
    staticClass: "avatar-uploader-wrap"
  }, [_c('i', {
    staticClass: "avatar-uploader-icon el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-desc"
  }, [_vm._v("点击添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-tip"
  }, [_vm._v("支持jpg／png格式")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "example_img",
    attrs: {
      "src": require("./image/example4.jpg"),
      "width": "240",
      "height": "180",
      "class": "example_img"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "image_info"
  }, [_vm._v("* 必须使用有效期内的二代身份证，身份证号码及头像清晰可见，完整身份证正面照。")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.idcardbackloading),
      expression: "idcardbackloading"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterface,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'idcardback',
        format: 'cors',
        userid: _vm.shopInfo.userid
      }
    }
  }, [(_vm.shopInfo.idcardback_url) ? _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.shopInfo.idcardback_url
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "img-tip"
  }, [_vm._v("重新上传>")])]) : _c('div', {
    staticClass: "avatar-uploader-wrap"
  }, [_c('i', {
    staticClass: "avatar-uploader-icon el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-desc"
  }, [_vm._v("点击添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-tip"
  }, [_vm._v("支持jpg／png格式")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "example_img",
    attrs: {
      "src": require("./image/example3.jpg"),
      "width": "240",
      "height": "180",
      "class": "example_img"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "image_info"
  }, [_vm._v("* 必须使用有效期内的二代身份证，有效期清晰可见，完整身份证反面照。")]), _vm._v(" "), (_vm.formList.includes('idcardinhand')) ? _c('div', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.idcardinhandloading),
      expression: "idcardinhandloading"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterface,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'idcardinhand',
        format: 'cors',
        userid: _vm.shopInfo.userid
      }
    }
  }, [(_vm.shopInfo.idcardinhand_url) ? _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.shopInfo.idcardinhand_url
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "img-tip"
  }, [_vm._v("重新上传")])]) : _c('div', {
    staticClass: "avatar-uploader-wrap"
  }, [_c('i', {
    staticClass: "avatar-uploader-icon el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-desc"
  }, [_vm._v("点击添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-tip"
  }, [_vm._v("支持jpg／png格式")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "example_img",
    attrs: {
      "src": require("./image/example5.jpg"),
      "width": "240",
      "height": "180",
      "class": "example_img"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "image_info"
  }, [_vm._v("* 必须使用有效期内的二代身份证，身份证本人手持证件，正面展示。")])], 1) : _vm._e(), _vm._v(" "), (_vm.formList.includes('groupphoto')) ? _c('div', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.groupphotoloading),
      expression: "groupphotoloading"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterface,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'groupphoto',
        format: 'cors',
        userid: _vm.shopInfo.userid
      }
    }
  }, [(_vm.shopInfo.groupphoto_url) ? _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.shopInfo.groupphoto_url
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "img-tip"
  }, [_vm._v("重新上传")])]) : _c('div', {
    staticClass: "avatar-uploader-wrap"
  }, [_c('i', {
    staticClass: "avatar-uploader-icon el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-desc"
  }, [_vm._v("点击添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-tip"
  }, [_vm._v("支持jpg／png格式")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "example_img",
    attrs: {
      "src": require("./image/example9.jpg"),
      "width": "240",
      "height": "180",
      "class": "example_img"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "image_info"
  }, [_vm._v("* 请上传收款人手持身份证与店内景的合影照片，并保证身份证内容清晰。")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group fix-unique"
  }, [_c('i', {
    staticClass: "divider-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("上传连锁店分店说明")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.subshopdescloading),
      expression: "subshopdescloading"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "on-progress": _vm.startAvatarUpload,
      "action": _vm.uploadInterface,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.avatarSuccess,
      "on-error": _vm.avatarFailed,
      "data": {
        category: 1,
        source: 1,
        tag: 'subshopdesc',
        userid: _vm.shopInfo.userid,
        format: 'cors'
      }
    }
  }, [(_vm.shopInfo.subshopdesc_url) ? _c('div', {
    staticClass: "avatar-wrap"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.shopInfo.subshopdesc_url
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "img-tip"
  }, [_vm._v("重新上传>")])]) : _c('div', {
    staticClass: "avatar-uploader-wrap"
  }, [_c('i', {
    staticClass: "avatar-uploader-icon el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "avatar-desc"
  }, [_vm._v("点击添加图片")]), _vm._v(" "), _c('div', {
    staticClass: "avatar-tip"
  }, [_vm._v("支持jpg／png格式")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "image_info"
  }, [_c('a', {
    staticClass: "down-doc",
    attrs: {
      "href": "https://near.qfpay.com.cn/op_upload/137/151394230826.doc",
      "download": ""
    }
  }, [_vm._v("点此下载文件，请填写后加盖公章并拍照重新上传")])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCreateSubShop('upload_info')
      }
    }
  }, [_vm._v("放弃创建")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "155px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backToPrePage
    }
  }, [_vm._v("返回上一页")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 1
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "155px"
    },
    attrs: {
      "type": "success",
      "disabled": _vm.btnLocked
    },
    on: {
      "click": _vm.signUp
    }
  }, [_vm._v("确认提交")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding-bottom": "2px"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "mydialog",
    attrs: {
      "visible": _vm.isShowCommitDone,
      "modal": true,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowCommitDone = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.shopInfo
    }
  }, [_c('el-form-item', {
    staticClass: "done-icon"
  }, [_c('i', {
    staticClass: "el-icon-check OK"
  }), _vm._v(" "), _c('span', {
    staticClass: "done-text"
  }, [_vm._v("分店创建成功！")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "done-desc"
  }, [_vm._v("分店帐号：" + _vm._s(_vm.shopInfo.shopAccout))]), _vm._v(" "), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "dialog-footer"
  }, [_c('el-button', {
    staticClass: "backToSMBtn",
    on: {
      "click": _vm.backToShopManagement
    }
  }, [_vm._v("门店管理")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.continueToCreateSubShop
    }
  }, [_vm._v("继续创建分店")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("分店账户信息设置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("图片凭证信息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5942d277"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/chainmanage/createSubShop.vue
// module id = 830
// module chunks = 0